<div mat-dialog-title *ngIf="data.title">
    <h1>{{ data.title }}</h1>
</div>
<div mat-dialog-content>
    <div class="p-3 text-center">
        <p *ngIf="data.message1" style="font-weight: bold" [innerHTML]="data.message1"></p>
        <p *ngIf="data.message2" [innerHTML]="data.message2"></p>
        <p *ngIf="data.message3" style="font-weight: bold" [innerHTML]="data.message3"></p>
    </div>
</div>
<div mat-dialog-actions style="display: flex; justify-content: center; align-items: center; padding: 10px;">
    <button mat-button class="mat-raised-button center mat-elevation-z0" [mat-dialog-close]="true" color="primary">Ok</button>
</div>